import { render, staticRenderFns } from "./header-countdown-config.vue?vue&type=template&id=fb4c5062&scoped=true&"
import script from "./header-countdown-config.vue?vue&type=script&lang=ts&"
export * from "./header-countdown-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4c5062",
  null
  
)

export default component.exports